import('./title.css')
export default function Title(){
    BaseConstructor.call(this)

    let elements = {}

    this.generate = (text) =>{
        elements.container = this.createElement('div', 'view-title-container', text)
        return elements.container
    }
}

Title.prototype = Object.create(BaseConstructor.prototype)